import { takeLatest, put, all } from 'redux-saga/effects';
import * as types from '../store/actionTypes';
import {
  loginService,
  userMeService,
  resetPasswordService,
  forgotPasswordService,
} from '../services/authService';
import {
  loginSuccessAction,
  loginFailAction,
  userMeSuccessAction,
  userMeFailAction,
  resetPasswordFailAction,
  resetPasswordSuccessAction,
  forgotPasswordSuccessAction,
  forgotPasswordFailAction,
} from '../store/actions/authActions';
import { notification } from 'antd';

// Login
export function* logInWithCredentials({ payload: { email, password } }) {
  try {
    const user = yield loginService(email, password);
    //Do store session token and data
    if (user.data.status_code === 200) {
      localStorage.setItem('token', user.data.data.token);
      yield put(loginSuccessAction(user.data.data));
    } else {
      yield put(loginFailAction(user.detail));
    }
  } catch (error) {
    localStorage.removeItem('token');
    yield put(loginFailAction(error.response.data.detail));
  }
}

//Forgot Password
export function* sendPasswordResetLink({ payload }) {
  console.log('sendPasswordResetLink', payload);
  try {
    yield forgotPasswordService(payload.email);
    yield put(forgotPasswordSuccessAction());
    notification['success']({
      message: 'Password reset successful.',
      description: 'Password reset successfully done',
    });
  } catch (error) {
    yield put(forgotPasswordFailAction(error));
    notification['error']({
      message: 'Password reset failed.',
      description: 'Password reset failed',
    });
  }
}

// Reset Password
export function* resetPasswordWithMail({
  payload: { reset_token, email, password },
}) {
  try {
    yield resetPasswordService(reset_token, email, password);
    yield put(resetPasswordSuccessAction());
  } catch (error) {
    yield put(resetPasswordFailAction(error));
  }
}

export function* userMeCall({ payload }) {
  try {
    const user = yield userMeService(payload);
    //Do store session token and data
    if (user.data.status_code === 200) {
      // localStorage.setItem("token", user.data.data.token);
      yield put(userMeSuccessAction(user.data.data));
    } else {
      yield put(userMeFailAction(user.data.data));
    }
  } catch (error) {
    yield put(userMeFailAction(error));
  }
}

export function* onLoginRequest() {
  yield takeLatest(types.LOGIN_REQUEST, logInWithCredentials);
}

export function* onUserMeRequest() {
  yield takeLatest(types.USER_ME_REQUEST, userMeCall);
}

export function* onForgotPasswordRequest() {
  yield takeLatest(types.FORGOT_PASSWORD_REQUEST, sendPasswordResetLink);
}

export function* resetPasswordRequest() {
  yield takeLatest(types.RESET_PASSWORD_REQUEST, resetPasswordWithMail);
}

export function* authSaga() {
  yield all([
    onLoginRequest(),
    onUserMeRequest(),
    onForgotPasswordRequest(),
    resetPasswordRequest(),
  ]);
}
